import { HISTORY_TYPES, IHistoryItem } from 'types/History';
import AttachmentContent from './Content/AttachmentContent';
import BillingContent from './Content/BillingContent';
import ClaimContent from './Content/ClaimContent';
import ComplaintContent from './Content/ComplaintContent';
import FraudContent from './Content/FraudContent';

type Props = {
	item: IHistoryItem;
};

const HistoryItemContent = ({ item }: Props) => {
	// attachment
	if (item.typeHistory === HISTORY_TYPES.ATTACHMENT) {
		return <AttachmentContent item={item} isNew={item.isNew} />;
	}

	// billing
	if (item.typeHistory === HISTORY_TYPES.BILLING) {
		return <BillingContent item={item} />;
	}

	// claim
	if (item.typeHistory === HISTORY_TYPES.CLAIM) {
		return <ClaimContent item={item} />;
	}

	// return
	if (item.typeHistory === HISTORY_TYPES.RETURN) {
		return <ClaimContent item={item} />;
	}

	// complaint
	if (item.typeHistory === HISTORY_TYPES.COMPLAINT) {
		return <ComplaintContent item={item} />;
	}

	// fraud
	if (item.typeHistory === HISTORY_TYPES.FRAUD) {
		return <FraudContent item={item} />;
	}

	return <></>;
};

export default HistoryItemContent;
